import { Bar, ChartProps } from 'react-chartjs-2'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Plugin } from 'chart.js'
import { EmptyState } from '../EmptyState'
import { ErrorState } from '../ErrorState'
import { LoadingState } from '../LoadingState'
import clsx, { ClassValue } from 'clsx'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
)

export type BarChartProps = {
  options?: ChartProps<'bar'>['options'] & { plugins: { htmlLegend?: { containerID: string } } }
  legend?: {
    position: 'top' | 'bottom' | 'right' | 'left'
    labels: { borderRadius: number }
  }
  title?: string
  data?: {
    labels?: string[]
    datasets?: {
      label: string
      data: number[]
      backgroundColor: string | string[]
      stacked?: string
      [x: string]: any
    }[]
  }
  stacked?: boolean | false
  plugins?: Plugin<'bar'>[]
  loading?: boolean
  error?: boolean
  className?: ClassValue
}

export function BarChart (props: BarChartProps) {
  const { legend, title, data, stacked, options, plugins, loading, error, className } = props

  const labels = data?.labels
  const datasets = data?.datasets

  const isEmpty = !datasets || datasets.flatMap(item => item.data).length === 0

  const optionsDefault: ChartProps<'bar'>['options'] = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: legend || { display: false },
      title: {
        display: !!title,
        text: title
      }
    },
    scales: {
      x: {
        stacked,
        grid: {
          color: 'transparent'
        }
      },
      y: {
        stacked
      }
    }
  }

  return (
    <>
      {error && <ErrorState />}
      {loading && <LoadingState />}
      {isEmpty && !error && !loading && <EmptyState />}
      {!error && !loading && !isEmpty && datasets && labels && (
      <div className={clsx('h-full cursor-pointer', isEmpty && 'hidden', className)}>
        <Bar
          options={options ?? optionsDefault}
          data={{
            datasets,
            labels
          }}
          plugins={plugins}
        />
      </div>)}
    </>
  )
}
